<template>
    <div>
        <button class="button is-outlined is-info table-button" @click="openModal">{{ buttonLabel }}</button>
        <Modal @onConfirm="onConfirm" @onClose="onClose" :isOpen="isOpen" :modalTitle="$t('modules.evaluations.index.evalsList.addEvalModalTitle')">

            <div class="select refs_select" v-if="positionsList.length > 0">
                <select v-model="selectedPosition">
                    <option v-for="position in positionsList" :index="position.id" :value="position" :key="position.id" >{{ position.name }}</option>
                </select>
            </div>
            <div class="refs_select_no_positions" v-else>
                <span>
                    {{ $t('modules.evaluations.index.evalsList.noPositionYet') }}
                </span>
            </div>
        </Modal>
    </div>
</template>

<script>
import userCanAccess from '@/modules/auth/stores/helpers/checkAccess.js'

export default {
    name: 'AddToPositionModal',
    props: ['evaluation', 'positionsList', 'index'],
    components: {

    },
    beforeCreate() {
        // this.$store.dispatch('EvalStore/indexEvals', {page: 1})
    },
    data(){
        return {
            isOpen: false,
            selectedPosition: null
        }
    },
    computed: {
        buttonLabel(){
            if(this.evaluation.sight_group_id){
                return this.$t('modules.evaluations.index.evalsList.changePosition')
            }else{
                return this.$t('modules.evaluations.index.evalsList.assignPosition')
            }
        }
    },
    methods: {
        openModal(){
            if( userCanAccess('features', 'create_sight_group') &&  userCanAccess('features', 'create_evaluation')){
                this.isOpen = true
                this.$store.dispatch('PositionStore/indexPositions', {page: 'all'})
            }else{
                this.$router.push('/unautorized'); 
            }
        },
        onConfirm(){
            if(this.positionsList.length > 0){
                this.$store.dispatch('EvalStore/changeSightGroup', {id: this.evaluation.id, sight_group_id: this.selectedPosition.id})
                this.isOpen = false
                const evalData = {
                    evalIndex: this.index, positionName: this.selectedPosition.name
                }
            }else{
                this.isOpen = false    
            }
            
        },
        onClose(){
            this.isOpen = false
        },
    }
}
</script>

<style lang="scss" scoped>
    .refs_select{
        width: 100%;
        select{
            width: 100%;
        }
    }

</style>